export enum HubConnectionEvent {
    SUBSCRIBE = 'SubToFormingSessionAsync',
    PLACE_ARTICLE_GROUP = 'PlaceArticleGroupAsync',
    PLACE_ARTICLE_GROUPS = 'PlaceArticleGroupsAsync',
    DELETE_ARTICLES = 'DeleteArticlesAsync'
}